import { render, staticRenderFns } from "./ExamMetaInfo.vue?vue&type=template&id=dd1fcda8&scoped=true"
import script from "./ExamMetaInfo.vue?vue&type=script&lang=js"
export * from "./ExamMetaInfo.vue?vue&type=script&lang=js"
import style0 from "./ExamMetaInfo.vue?vue&type=style&index=0&id=dd1fcda8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1fcda8",
  null
  
)

export default component.exports